import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const seasonApi = {
    getList() {
        return httpClient.get(API_ROUTES.season_list)
    },

    create(formData) {
        return httpClient.post(API_ROUTES.season_insert, formData)
    },

    setCurrent(formData) {
        return httpClient.post(API_ROUTES.season_first, formData)
    },

    delete(formData) {
        return httpClient.post(API_ROUTES.season_delete, formData)
    },
}
